// Deep Link route allowlist (#1693, spec.md §6.1-6.2).
//
// A link that reaches the app — a Universal Link / App Link tap, or a
// Pending Action resumed after login — is only ever navigated to if its
// path matches one of these patterns. An unrecognized path is rejected: it
// is never stored as an arbitrary URL and injected into the WebView.
//
// Only routes that make sense as the TARGET of an external link (email,
// SMS, push, a QR/NFC station tag) are listed here — not the entire route
// table in src/pages/Routes.js. Internal-only navigation does not need to
// survive a cold start or a Pending Action round-trip.
//
// Kept in sync BY HAND with functions/deepLinks/allowedRoutes.js — the
// server re-validates independently in resolvePendingAction (never trusts
// the client's own classification of its link). Deliberately NOT routed
// through the ENGINE TWIN mechanism (functions/scripts/engineFiles.mjs):
// that mirrors the salary engine, a different concern. Update both files
// together when a deep-linkable route is added or removed.

const SEGMENT = '[^/]+'

const ALLOWED_ROUTE_PATTERNS = [
  // Employee self-service (#186/#408 station links, notifications) — no
  // employer id in the path; any authenticated user may land here.
  /^\/attendance$/,
  /^\/attendance\/requests$/,
  /^\/attendance\/sick-day$/,
  /^\/attendance\/vacation$/,
  /^\/attendance\/reserve-duty$/,
  /^\/notifications$/,
  // Auth-transition targets (#325 invite redeem, email sign-in link).
  /^\/signed-up$/,
  /^\/login\/twilio-phone$/,
  // Employer-scoped manager routes — resolvePendingAction additionally
  // requires assertManagesEmployer(request, employerId) for these.
  new RegExp(`^/employers/${SEGMENT}/dashboard$`),
  new RegExp(`^/employers/${SEGMENT}/reports$`),
  new RegExp(`^/employers/${SEGMENT}/absences$`),
  new RegExp(`^/employers/${SEGMENT}/agreements$`),
  new RegExp(`^/employers/${SEGMENT}/agreements/${SEGMENT}$`),
  new RegExp(`^/employers/${SEGMENT}/calculations$`),
  new RegExp(`^/employers/${SEGMENT}/calculations/${SEGMENT}$`),
  new RegExp(`^/employers/${SEGMENT}/monthly-approval/${SEGMENT}/${SEGMENT}$`),
]

/** true iff `pathname` (no query string) matches an allowlisted deep-link target. */
export function isAllowedDeepLinkPath(pathname) {
  if (typeof pathname !== 'string' || !pathname) return false
  return ALLOWED_ROUTE_PATTERNS.some(pattern => pattern.test(pathname))
}
